import { TeacherSearchSuggestions } from "@outschool/gql-backend-generated";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";

import {
  TeacherSearchSuggestionsQuery,
  TeacherSearchSuggestionsQueryVariables
} from "../../../shared/generated/graphql";

const TeacherSuggestionsQuery = gql`
  query TeacherSearchSuggestions($query: String!, $size: Int) {
    teacherSearchSuggestions(search: { query: $query }, size: $size) {
      teachers {
        uid
        name
        photo
        leader_link
        averageActivityStarRating
        reviewCount
        educatorTiers
      }
      term
    }
  }
`;

export function useTeacherSearchSuggestions(
  query: string,
  size: number
): TeacherSearchSuggestions {
  const { data } = useQueryWithPreviousData<
    TeacherSearchSuggestionsQuery,
    TeacherSearchSuggestionsQueryVariables
  >(TeacherSuggestionsQuery, {
    variables: { query, size },
    skip: !query || !query.length
  });

  if (!data) {
    return {
      teachers: [],
      term: ""
    };
  }

  const { teacherSearchSuggestions } = data;
  return teacherSearchSuggestions as TeacherSearchSuggestions;
}
